import { create } from "zustand";

export const MODAL_TYPES = {
    EDIT_PERSONAL_DATA: "editPersonalData",
    EDIT_SHIPPING_ADDRESS: "editShippingAddress",
    EDIT_BILLING_ADDRESS: "editBillingAddress",
    USER_ID_VERIFICATION: "userIdVerification",
} as const;

export type ModalType = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES] | null;

interface ModalState {
    type: ModalType;
    props: any;
    open: (type: ModalType, props?: any) => void;
    close: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
    type: null,
    props: null,
    open: (type, props) => set({ type, props }),
    close: () => set({ type: null, props: null }),
}));
